import React, { ReactChild, ReactChildren } from "react";

const PageHeaderTitle = ({
  children,
}: {
  children?: ReactChild | ReactChildren;
}) => {
  return (
    <span className="text-4xl leading-10 print:hidden font-extrabold">
      {children}
    </span>
  );
};

export default PageHeaderTitle;
